import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../services/AuthService';

/**
 * UserProtectedRoutes
 * Decorator component to protect user routes.
 * Redirects to login if the user is not authenticated.
 */
export const UserProtectedRoutes = ({ children }) => {
    const { user } = useAuth();
    const location = useLocation();

    if (!user) {
        // Redirect to login while saving the attempted location
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

/**
 * UserPublicRoutes
 * Decorator component for public auth routes.
 * Redirects to dashboard if the user is already authenticated.
 */
export const UserPublicRoutes = ({ children }) => {
    const { user } = useAuth();
    const location = useLocation();

    if (user) {
        // Redirect to dashboard or previous location
        const from = location.state?.from?.pathname || "/dashboard";
        return <Navigate to={from} replace />;
    }

    return children;
};

export default UserProtectedRoutes;
